var RedirectKeys;
(function (RedirectKeys) {
    RedirectKeys["ProviderName"] = "_stitch_redirect_provider_name";
    RedirectKeys["ProviderType"] = "_stitch_redirect_provider_type";
    RedirectKeys["State"] = "_stitch_redirect_state";
})(RedirectKeys || (RedirectKeys = {}));
export default RedirectKeys;
//# sourceMappingURL=RedirectKeys.js.map